var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoriteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2852",
    "data-name": "Grupo 2852",
    transform: "translate(-30 -359)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2811",
    "data-name": "Grupo 2811",
    transform: "translate(0 -2.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2810",
    "data-name": "Grupo 2810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2767",
    "data-name": "Grupo 2767",
    transform: "translate(30 361.076)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1384",
    "data-name": "Ret\\xE2ngulo 1384",
    width: 40,
    height: 40,
    rx: 10,
    fill: "#b895ff",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("path", {
    id: "SAVE_TAG",
    "data-name": "SAVE TAG",
    d: "M3,3H16V18L9.5,13.714,3,18Z",
    transform: "translate(40.385 368.5)",
    fill: "#b895ff",
    stroke: "#b895ff",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteIcon);
export default __webpack_public_path__ + "static/media/favoriteIcon.02b1e21d26dbbb9c63ebb92836395918.svg";
export { ForwardRef as ReactComponent };